export var searchSymbolMapper = function (data) {
    var _a, _b;
    var result = { data: { symbolList: [] } };
    if (data && (data === null || data === void 0 ? void 0 : data.resLst) && ((_a = data === null || data === void 0 ? void 0 : data.resLst) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        (_b = data === null || data === void 0 ? void 0 : data.resLst) === null || _b === void 0 ? void 0 : _b.map(function (symbol) {
            var symbolData = {};
            symbolData.displayName = symbol.dpNm;
            symbolData.displayValue = symbol.dpVal;
            symbolData.index = symbol.idx;
            symbolData.instrument = symbol.inst;
            symbolData.exchange = symbol.exc;
            result.data.symbolList.push(symbolData);
        });
    }
    return result;
};
